import axios from "axios";
import { getSeasonPick } from "../hooks/useSeason";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const season = getSeasonPick();
  if (season !== "auto" && !cfg.skipSeason) cfg.params = { season, ...cfg.params };
  return cfg;
});

export const getMeta = (opts) =>
  client.get("/meta", { skipSeason: !!opts?.auto }).then((r) => r.data);
export const getTeams = () => client.get("/teams").then((r) => r.data);
export const getTeam = (id) => client.get(`/teams/${id}`).then((r) => r.data);
export const getSchedule = (week) =>
  client.get("/schedule", { params: week ? { week } : {} }).then((r) => r.data);
export const getScores = () => client.get("/scores").then((r) => r.data);
export const getStandings = () => client.get("/standings").then((r) => r.data);
export const getLeaders = () => client.get("/players/leaders").then((r) => r.data);
export const getPlayers = (category) =>
  client.get("/players", { params: category ? { category } : {} }).then((r) => r.data);
export const getPlayoffs = () => client.get("/playoffs").then((r) => r.data);
export const getPlayerProfile = (id) => client.get(`/players/profile/${id}`).then((r) => r.data);
export const getHeadToHead = (a, b) =>
  client.get("/head-to-head", { params: { a, b } }).then((r) => r.data);
export const refreshData = () => client.post("/admin/refresh").then((r) => r.data);
export const getPostseason = () => client.get("/postseason").then((r) => r.data);
export const getWeeklyLeaders = (week) =>
  client.get("/weekly-leaders", { params: { week } }).then((r) => r.data);

export default client;
